export const CELL_WIDTH = 100;
export const CELL_HEIGHT = 25;
export const TOTAL_ROWS = 100000;
export const TOTAL_COLS = 26;